import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { NotificacaoInterna } from '../../Services/Notification';
import apiAdonis from '../../Services/adonis';
import LinePercent from './components/selicPercent';

import * as Component from './style';
import viewModel from './viewModel';

const View: React.FC<viewModel> = (viewModel) => {
    /* #region  Variáveis  */
    const History = useHistory();
    /* #endregion */

    /* #region  Funções  */
    useEffect(() => {
        async function componentDidMount() {
            await VerifyToken();
        }
        componentDidMount();
    }, []);
    async function VerifyToken() {

        await apiAdonis.post('/verify', {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        }).then(async result => {
            if (result.data.check) {
                return null
            }
            else {
                NotificacaoInterna.ExibirNotificacao("Acesso Expirado!", "Seu acesso à aplicação foi expirado!", NotificacaoInterna.TipoDeNotificacao.Informacao);
                History.replace("/");
                window.location.reload();
            }
        });
    }
    return (
        <Component.Container>
            <LinePercent/>
            {/* <div className="endereco">
                <img src={IconeHome} alt="" />
                <div className="bar">/</div>
                <div className="place">Menu</div>
            </div>
            <Component.Menu>
                <Component.Title></Component.Title>
                <div className="menuItemDiv">
                </div>
            </Component.Menu> */}
        </Component.Container>
    );
    /* #endregion */
};

export class Controller {
    public static AcessarForgotPassword(History: any): void {
        History.push("/ForgotPassword");
        window.location.reload();
    };
    public static AcessarPaginaAcompanhamentoDeSala(History: any): void {
        if (true) {
            History.push("/AcompanhamentoDeSala");
            window.location.reload();
        }
        else {
            NotificacaoInterna.ExibirNotificacao("Acesso Negado", "Você não possui permissão para acessar essa página!", NotificacaoInterna.TipoDeNotificacao.Informacao);
        }
    };
    public static AcessarPaginaBordero(History: any): void {
        if (true) {
            History.push("/Bordero");
            window.location.reload();
        }
        else {
            NotificacaoInterna.ExibirNotificacao("Acesso Negado", "Você não possui permissão para acessar essa página!", NotificacaoInterna.TipoDeNotificacao.Informacao);
        }
    };
    public static AcessarPaginaConfiguracoes(History: any): void {
        NotificacaoInterna.ExibirNotificacao("Função em desenvolvimento", "Aguarde! Estamos desenvolvendo esta funcionalidade!", NotificacaoInterna.TipoDeNotificacao.Informacao);
    };
    public static AcessarPaginaDisponibilidade(History: any): void {
        if (true) {
            History.push("/Disponibilidade");
            window.location.reload();
        }
        else {
            NotificacaoInterna.ExibirNotificacao("Acesso Negado", "Você não possui permissão para acessar essa página!", NotificacaoInterna.TipoDeNotificacao.Informacao);
        }
    };
    public static AcessarPaginaLeads(History: any): void {
        NotificacaoInterna.ExibirNotificacao("Função em desenvolvimento", "Aguarde! Estamos desenvolvendo esta funcionalidade!", NotificacaoInterna.TipoDeNotificacao.Informacao);
    };
    public static AcessarPaginaMeusContratos(History: any): void {
        if (true) {
            History.push("/MeusContratos");
            window.location.reload();
        }
        else {
            NotificacaoInterna.ExibirNotificacao("Acesso Negado", "Você não possui permissão para acessar essa página!", NotificacaoInterna.TipoDeNotificacao.Informacao);
        }
    };
    public static AcessarPaginaNFSe(History: any): void {
        if (true) {
            History.push("/NFSe");
            window.location.reload();
        }
        else {
            NotificacaoInterna.ExibirNotificacao("Acesso Negado", "Você não possui permissão para acessar essa página!", NotificacaoInterna.TipoDeNotificacao.Informacao);
        }
    };
    public static AcessarPaginaPropostasPendentes(History: any): void {
        if (true) {
            History.push("/PropostasPendentes");
            window.location.reload();
        }
        else {
            NotificacaoInterna.ExibirNotificacao("Acesso Negado", "Você não possui permissão para acessar essa página!", NotificacaoInterna.TipoDeNotificacao.Informacao);
        }
    };
    public static AcessarPaginaProspeccao(History: any): void {
        NotificacaoInterna.ExibirNotificacao("Função em desenvolvimento", "Aguarde! Estamos desenvolvendo esta funcionalidade!", NotificacaoInterna.TipoDeNotificacao.Informacao);
    };
    public static AcessarPaginaReserva(History: any): void {
        NotificacaoInterna.ExibirNotificacao("Função em desenvolvimento", "Aguarde! Estamos desenvolvendo esta funcionalidade!", NotificacaoInterna.TipoDeNotificacao.Informacao);
        return;
    };
    public static AcessarPaginaVendaDireta(History: any): void {
        if (true) {
            History.push("/VendaDireta");
            window.location.reload();
        }
        else {
            NotificacaoInterna.ExibirNotificacao("Acesso Negado", "Você não possui permissão para acessar essa página!", NotificacaoInterna.TipoDeNotificacao.Informacao);
        }
    };
    public static AcessarSimuladorDePropostas(History: any): void {
        if (true) {
            History.push("/SimuladorDePropostas");
            window.location.reload();
        }
        else {
            NotificacaoInterna.ExibirNotificacao("Acesso Negado", "Você não possui permissão para acessar essa página!", NotificacaoInterna.TipoDeNotificacao.Informacao);
        }
    };
};

export default View;